import { apiService } from "@/services";
import { settings } from "@/settings";
import { ImportsClient } from "./GeneratedClients";

const importRepository = new ImportsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { importRepository };
